import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64eac95c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64eac95c')) {
      api.createRecord('64eac95c', component.options)
    } else {
      api.reload('64eac95c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64eac95c", function () {
      api.rerender('64eac95c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activiti/index.vue"
export default component.exports